module.exports = __webpack_public_path__ + "img/icon_lvjing_yuantu_normal@2x.6d4ada41.png";